import type { ColumnProps } from 'antd/lib/table';
import { Table } from 'antd';

export default Table;

export type { ColumnProps };
